import { useQuery } from "@tanstack/react-query";
import { brandFilterApi } from "../module/brand-filter/api/api"

import { useNavigate, useSearchParams } from "react-router";

export function useBrandFilter() {
    const [searchParams, setSearchParams] = useSearchParams();
    const navigate = useNavigate();

    // Получаем значения из URL, устанавливая дефолтное значение '' если параметр отсутствует
    const carTypeId = searchParams.get("carTypeId") || "1";
    const brandId = searchParams.get("brandId") || "";
    const engineId = searchParams.get("engineId") || "";
    const enabled = searchParams.get("enabled") || "";
    const car_model_id = searchParams.get("car_model_id") || "";
    const nameV = searchParams.get("nameV") || "";



    // Функция для обновления searchParams
    const updateSearchParams = (newParams, preventScrollReset = true) => {
        // Создаем новый объект параметров на основе текущего URL
        const updatedParams = {};
        for (const [key, value] of searchParams) {
            updatedParams[key] = value;
        }
        // Обновляем переданные поля
        Object.entries(newParams).forEach(([key, value]) => {
            if (value) {
                updatedParams[key] = value;
            } else {
                delete updatedParams[key];
            }
        });
        setSearchParams(updatedParams, { preventScrollReset: preventScrollReset, replace: true });
    };


    function handleCarTypeChange(value) {
        updateSearchParams({
            carTypeId: value,
            brandId: "",
            car_model_id: "",
            nameV: "",
            engineId: "",
        });
    }

    function handleBrandIdChange(value) {
        updateSearchParams({
            brandId: value,
            car_model_id: "",
            nameV: "",
            engineId: "",
        });
    }

    function handle_car_model_id_change(value) {
        updateSearchParams({
            car_model_id: value,
            dateStart: "",
            nameV: "",
            engineId: "",
        });
    }


    function handleNameVChange(value) {
        updateSearchParams({
            nameV: value,
            engineId: "",
        });
    }

    function handleSetEngineId(value) {
        updateSearchParams({ engineId: value });
    }



    const handleQueryError = () => {
        navigate("/error");
    };

    const { data: brandsData, isLoading: isLoadingBrands } = useQuery({
        ...brandFilterApi.getBrandList({ carTypeId }),
        onError: handleQueryError
    });

    const { data: modelsData, isLoading: isLoadingModels } = useQuery({
        ...brandFilterApi.getModelsList({ carTypeId, brandId }),
        onError: handleQueryError
    });

    const { data: volumeNameData, isLoading: isLoadingVolume } = useQuery({
        ...brandFilterApi.getVolume({ car_model_id }),
        onError: handleQueryError
    });

    const { data, isLoading: isLoadingEngineProduct, refetch, isRefetching } = useQuery({
        ...brandFilterApi.getProducts({ car_model_id, name: nameV }),
        onError: handleQueryError
    });

    function handleSearchClick() {
        refetch();
    }

    return {
        carTypeId,
        brandId,
        engineId,
        enabled,
        handleCarTypeChange,
        handleBrandIdChange,
        handle_car_model_id_change,
        handleSetEngineId,
        handleSearchClick,
        brandsData,
        modelsData,
        isLoadingBrands,
        isLoadingModels,
        isLoadingVolume,
        isLoadingEngineProduct,
        volumeNameData,
        data,
        car_model_id,
        nameV,
        handleNameVChange,
        isRefetching
    };
}
